//@ts-ignore
import { toHz } from 'hertzbel';
import { SnapshotValidation, Snapshot } from 'types';
import { SnapshotTraceHistoryCombination } from '../types';

export function getValidatePropertyErrors(
  snapshot: SnapshotTraceHistoryCombination,
  validatedProperties: SnapshotValidation | null | undefined,
  needsValidation: boolean | undefined,
  inHistoryMode: boolean | undefined
) {
  if (!validatedProperties || needsValidation || inHistoryMode)
    return {
      portError: false,
      centerError: false,
      spanError: false,
      referenceError: false,
      rbwError: false,
      vbwError: false,
      attenError: false,
      preAmpError: false,
      hasInvalidProperties: false,
    };

  const validationErrors = {
    portError: snapshot.port !== validatedProperties.port,
    centerError: compareFrequencies(
      snapshot.center,
      validatedProperties.center
    ),
    spanError: compareFrequencies(snapshot.span, validatedProperties.span),
    referenceError: snapshot.reference !== validatedProperties.reference,
    rbwError:
      snapshot.rbw !== 'AUTO' &&
      compareFrequencies(snapshot.rbw, validatedProperties.rbw),
    vbwError:
      snapshot.vbw !== 'AUTO' &&
      snapshot.vbw.split(' ').length !== 1 &&
      compareFrequencies(snapshot.vbw, validatedProperties.vbw),
    attenError:
      snapshot.atten !== 'AUTO' && snapshot.atten === validatedProperties.atten,
    preAmpError: Number(snapshot.preamp) !== Number(validatedProperties.preamp),
  };

  return {
    ...validationErrors,
    hasInvalidProperties: Object.values(validationErrors).includes(true),
  };
}

function compareFrequencies(frequency: any, compareFreq: any) {
  const splitCompareFreq = compareFreq.split(' ');
  const splitFrequency = frequency.split(' ');
  if (splitCompareFreq.length < 2) return true;
  if (splitFrequency.length < 2) return true;
  const formatedCompareFreqValue =
    parseFloat(splitCompareFreq[0]).toString() + ' HZ';
  return toHz(frequency).toUpperCase() !== formatedCompareFreqValue;
}

export const checkIfAnalyzerInCrosspolMode = (
  snapshots: Snapshot[] | undefined
) => {
  if (!snapshots) return false;
  for (const snapshot of snapshots) {
    if (snapshot.crosspol_snapshot_id) return true;
  }
  return false;
};
